import get from 'lodash/get';
import { selectCloudInstance } from 'store/Config/selector';
import { initialState } from './reducer';

export const selectIsFetching = (state) => get(state, 'license.isFetching', initialState.isFetching);
export const selectCanViewSubscription = (state) => state.faraday.role === 'admin' && selectCloudInstance(state);
